import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appNumericValidate][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NumericValidateDirective, multi: true }],
})
export class NumericValidateDirective implements Validator {
  @Input('numericValidate') validateIndex: string;

  // Regex for validating numeric values (including negative and decimal numbers)
  private validationRegex = /^((0|-?([1-9]\d*))|(-?\d*[.]\d+))$/;

  validate(control: AbstractControl): ValidationErrors | null {
    const validationKey = 'numeric_' + this.validateIndex;
    const value = control.value;
    const isValid = value == null || value == '' || this.validationRegex.test(value);

    if (!isValid) {
      return { [validationKey]: true };
    }

    return null;
  }
}
